import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { ButtonGroup, Form, FormGroup, Label, Col, Row } from "reactstrap";

import { ROUTES, insertIdtoUrl } from "constants/Routes.js";
import "assets/scss/customRadio.css";
import {userFormValidator, inputFocusHandler} from 'utils/userFormValidate';
import {getUserInvitation} from "../../../../constants/localStorageManager";

class BusinessUserForm extends Component {
  render() {
    const { first_name,middle_name,last_name,password,password_confirmation } = this.props.user;
    const {addUser} = this.props;
    function validateUserForm(event){
      const result = userFormValidator(event);
      if(result) addUser();
    }

    return (
      <div className="user-form" id='userForm'>
        <Form>
              <FormGroup>
                <Label>First Name:</Label>
                <input
                  className="form-control"
                  name="first_name"
                  value={first_name}
                  onChange={this.props.handleChange}
                  type='text'
                  onBlur={inputFocusHandler}
                  pattern="^[A-Z,a-z ,.'-]+$"
                  required
                />
                <div className='row error' id='first_nameError'></div>
              </FormGroup>
           
          
              <FormGroup>
                <Label>Middle Name:</Label>
                <input
                  type='text'
                  className="form-control"
                  name="middle_name"
                  value={middle_name}
                  onChange={this.props.handleChange}
                  pattern="^[A-Z,a-z ,.'-]+$"
                />
              </FormGroup>
            
              <FormGroup>
                <Label>Last Name:</Label>
                <input
                  type='text'
                  className="form-control"
                  name="last_name"
                  value={last_name}
                  onChange={this.props.handleChange}
                  onBlur={inputFocusHandler} 
                  pattern="^[A-Z,a-z ,.'-]+$"
                  required
                />
                <div className='row error' id='last_nameError'></div>
              </FormGroup>
           
          
          
              <FormGroup>
                <Label>Password:</Label>
                <input
                  type='password'
                  id='password'
                  className="form-control"
                  name="password"
                  value={password}
                  minLength="6"
                  onChange={this.props.handleChange}
                  onBlur={inputFocusHandler} required
                />
                <div className='row error' id='passwordError'></div>
              </FormGroup>
            
            
              <FormGroup>
                <Label>Confirm Password:</Label>
                <input
                  type='password'
                  className="form-control"
                  id="confirmPassword"
                  name="password_confirmation"
                  value={password_confirmation}
                  minLength="6"
                  onChange={this.props.handleChange}
                  onBlur={inputFocusHandler} 
                  required
                />
                <div className='row error' id='password_confirmationError'></div>
              </FormGroup>
            
          <div className="float-right">
            <button
            type='button'
            onClick={validateUserForm.bind(this)}
            className="btn btn-add-new"//to-do only save if all fields are valid
            >
             Continue
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default BusinessUserForm;



// WEBPACK FOOTER //
// ./src/components/businesses/tabs/business-users/BusinessUserForm.js